import { render, staticRenderFns } from "./SiteGroup.vue?vue&type=template&id=b71094a2&"
import script from "./SiteGroup.vue?vue&type=script&lang=ts&"
export * from "./SiteGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SiteGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports